import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Collapsible } from 'ncoded-component-library';
import MembersTable from '../MembersTable';
import useCallbackRef from 'hooks/useCallbackRef';
import { CollapsibleRef } from 'ncoded-component-library/build/components/molecules/Collapsible/Collapsible.component';
import useSellSideActions from '../../hooks/useSellSideActions';
import TagIcon from 'icons/Tag.icon';
import ResolvePopup from 'components/ResolvePopup';
import InformationcircleIcon from 'icons/Informationcircle.icon';
import useMembers from '../../../../hooks/useMembers';

import './SellSide.styles.scss';

type SellSideProps = {
  className?: string;
  onlyNew?: boolean;
  onClick?: () => void;
};

const SellSide: React.ForwardRefRenderFunction<
  CollapsibleRef,
  SellSideProps
> = (props, ref) => {
  const { className, onlyNew = false, onClick } = props;

  const [sellSide, sellSideRef] = useCallbackRef<CollapsibleRef>(null);

  const { sellSideMembers } = useMembers(onlyNew);

  const { RenderAddMemberDrawer, actionButton } = useSellSideActions();

  const { t } = useTranslation();

  const classes = classNames('sell-side', 'white-panel', className);

  useImperativeHandle(ref, () => sellSide, [sellSide]);

  return (
    <>
      <Collapsible
        className={classes}
        ref={sellSideRef}
        trigger={
          <div className="trigger" onClick={onClick}>
            <div className="trigger__title">
              <TagIcon />
              <p className="name">{t('sellSide')}</p>
              <ResolvePopup onHover popupContent={t('sellSideColleaguesPopup')}>
                <InformationcircleIcon />
              </ResolvePopup>

              <p>{t('numOfcolleagues', { count: sellSideMembers.length })}</p>
            </div>
            {!onlyNew && <div className="trigger__actions">{actionButton}</div>}
          </div>
        }
      >
        <MembersTable members={sellSideMembers} />
      </Collapsible>
      {RenderAddMemberDrawer}
    </>
  );
};

export default forwardRef(SellSide);
